// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "stock_take".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { stockTakeStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "stock_take" table (1:1 with a DB row, on the wire). */
export const stockTakeAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string().nullable(),
    description: z.string().nullable(),
    locationId: z.string().nullable(),
    status: z.enum(stockTakeStatusValues),
    createdById: z.string(),
    completedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=stockTake.js.map